/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TextSnippetVisibilityEnum } from './textSnippetVisibilityEnum';
import { TextSnippetPermissions } from './textSnippetPermissions';
import { TextSnippetOwner } from './textSnippetOwner';


/**
 * One snippet with its content; also creates and changes it.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedTextSnippet { 
    readonly id?: number;
    title?: string;
    tags?: Array<string>;
    visibility?: TextSnippetVisibilityEnum;
    readonly owner?: TextSnippetOwner | null;
    practice?: number | null;
    readonly practiceName?: string | null;
    readonly preview?: string;
    readonly permissions?: TextSnippetPermissions;
    readonly updatedAt?: string | null;
    content?: string;
}
export namespace PatchedTextSnippet {
}

export const PatchedTextSnippet_id_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_title_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedTextSnippet_tags_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_visibility_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_owner_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_practice_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_practiceName_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_preview_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_permissions_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_updatedAt_Validators: ValidatorFn[] =
    [ ];

export const PatchedTextSnippet_content_Validators: ValidatorFn[] =
    [ ];


